import { mapCampaignLinkListItem } from './mapCampaignLinkListItem'

const normalizeTimestamp = (value) => {
  if (!value) {
    return null
  }

  if (typeof value.seconds === 'number') {
    return { seconds: value.seconds }
  }

  if (typeof value.toDate === 'function') {
    return { seconds: Math.floor(value.toDate().getTime() / 1000) }
  }

  return null
}

const normalizePromoDate = (value) => {
  if (!value) {
    return null
  }

  if (typeof value === 'string') {
    return value
  }

  return normalizeTimestamp(value)
}

const normalizeStringArray = (value) => (Array.isArray(value) ? value.filter(Boolean) : [])

const normalizeProductFilter = (value) => {
  if (!value || typeof value !== 'object') {
    return null
  }

  try {
    return JSON.parse(JSON.stringify(value))
  } catch {
    return null
  }
}

export const mapCampaignLinkDetail = (id, data = {}) => ({
  ...mapCampaignLinkListItem(id, data),
  destinationUrl: data.destination_url || '',
  owner: data.responsible || '',
  shortPath: data.short_path || '',
  relatedBrandIds: Array.isArray(data.related_brand_ids) ? data.related_brand_ids : [],
  relatedBrandNames: Array.isArray(data.related_brand_names) ? data.related_brand_names : [],
  relatedCategorySource: data.related_category_source ?? null,
  relatedCategoryLevel: data.related_category_level ?? null,
  relatedGlobalCategoryId: data.related_global_category_id ?? null,
  relatedGlobalCategoryName: data.related_global_category_name ?? null,
  relatedOutletGlobalCategoryId: data.related_outlet_global_category_id ?? null,
  relatedCategoryPathLabel: data.related_category_path_label ?? null,
  relatedGlobalCategoryPath: normalizeStringArray(data.related_global_category_path),
  relatedProductFilter: normalizeProductFilter(data.related_product_filter),
  relatedProductId: data.related_product_id ?? null,
  relatedProductSource: data.related_product_source ?? null,
  relatedProductName: data.related_product_name ?? null,
  relatedProductBarcode: data.related_product_barcode ?? null,
  relatedProductLabel: data.related_product_label ?? null,
  relatedPromoId: data.related_promo_id ?? null,
  relatedPromoTitle: data.related_promo_title ?? null,
  relatedPromoStartDate: normalizePromoDate(data.related_promo_start_date),
  relatedPromoEndDate: normalizePromoDate(data.related_promo_end_date),
  relatedPromoSource: data.related_promo_source ?? null,
  campaignDate: normalizePromoDate(data.campaign_date),
})

export default mapCampaignLinkDetail
